// Size Guide Modal
document.addEventListener('DOMContentLoaded', function() {
  
  // Unit conversion functionality
  function initUnitConversion() {
    const mmCheckbox = document.getElementById('unit-mm');
    const inchCheckbox = document.getElementById('unit-inch');
    const diameterUnit = document.getElementById('diameter-unit');
    const circumferenceUnit = document.getElementById('circumference-unit');
    const diameterValues = document.querySelectorAll('.diameter-value');
    const circumferenceValues = document.querySelectorAll('.circumference-value');
    
    if (!mmCheckbox || !inchCheckbox) return;
    
    // Handle checkbox changes
    mmCheckbox.addEventListener('change', function() {
      if (this.checked) {
        inchCheckbox.checked = false;
        updateUnits('mm');
      } else if (!inchCheckbox.checked) {
        this.checked = true; // Keep at least one checked
      }
    });
    
    inchCheckbox.addEventListener('change', function() {
      if (this.checked) {
        mmCheckbox.checked = false;
        updateUnits('inch');
      } else if (!mmCheckbox.checked) {
        this.checked = true; // Keep at least one checked
      }
    });
    
    function updateUnits(unit) {
      if (unit === 'mm') {
        diameterUnit.textContent = '(MM)';
        circumferenceUnit.textContent = '(MM)';
        
        diameterValues.forEach(cell => {
          cell.textContent = cell.getAttribute('data-mm');
        });
        
        circumferenceValues.forEach(cell => {
          cell.textContent = cell.getAttribute('data-mm');
        });
      } else {
        diameterUnit.textContent = '(INCH)';
        circumferenceUnit.textContent = '(INCH)';
        
        diameterValues.forEach(cell => {
          cell.textContent = cell.getAttribute('data-inch');
        });
        
        circumferenceValues.forEach(cell => {
          cell.textContent = cell.getAttribute('data-inch');
        });
      }
    }
  }
  
  // IMPORTANT: Call the function to initialize it
  initUnitConversion();
});